import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { FeatureToggleProvider } from '@contexts/FeatureToggleContext';
import { ensureRegionParam } from '@helpers/ensureRegionParam';
import { THANK_YOU_PATHS } from '@helpers/constants';

export const wrapRootElement = ({ element }) => (
  <FeatureToggleProvider>
    <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_GOOGLE_RECAPTCHA_KEY}>
      <style>{`.grecaptcha-badge { visibility: hidden; }`}</style>
      {element}
    </GoogleReCaptchaProvider>
  </FeatureToggleProvider>
);

export const onRouteUpdate = ({ location }) => {
  scrollToAnchor(location);
  sessionStorage.setItem('locationKey', location.key);
  ensureRegionParam(location);

  window.dataLayer = window.dataLayer || [];

  const THANK_YOU_ROUTES = Object.values(THANK_YOU_PATHS).flat();
  const normalizePath = (path) => path.replace(/\/$/, '');
  const currentPath = normalizePath(location.pathname);

  // Check if current page is a Thank You page
  const isThankYouPage = THANK_YOU_ROUTES.some((path) => currentPath.startsWith(normalizePath(path)));

  if (isThankYouPage) {
    const daxId = location.state?.orderId;

    if (daxId) {
      window.dataLayer.push({
        event: 'formSubmissionComplete',
        orderId: daxId,
        pagePath: location.pathname,
      });
    }
  }
};

function scrollToAnchor(location) {
  const tryScroll = () => {
    if (!location || !location.hash) return;

    const id = decodeURIComponent(location.hash.replace('#', ''));
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }

    return false;
  };

  window.requestAnimationFrame(() => {
    if (!tryScroll()) {
      window.setTimeout(() => {
        tryScroll();
      }, 100);
    }
  });
}

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  window.history.scrollRestoration = 'manual';
  const [savedScrollPositionLeft, savedScrollPositionTop] = getSavedScrollPosition(location) || [0, 0];

  if (location && location.hash) {
    scrollToAnchor(location);
    return;
  }

  setTimeout(() => {
    window.scrollTo({
      top: savedScrollPositionTop,
      left: savedScrollPositionLeft,
      behavior: 'instant',
    });
  }, 600);

  return false;
};
